export default __webpack_public_path__ + "static/media/info-circle@2x1.6fdf1371.svg";